module.exports = __webpack_public_path__ + "media/images/flags/64/South-Korea-c0cd80c9664d73f276695544a504ff47.png";